import React, {useEffect, useState} from 'react';
import classnames from "classnames";
import styles from "./ContactUsForm.module.css";
import MyInput from "../ui/MyInput/MyInput";
import MyTextarea from "../ui/MyTextarea/MyTextarea";
import MyBtn from "../ui/MyBtn/MyBtn";
import {useFormik} from "formik";
import * as yup from "yup";
import CustomModal from "../ui/CustomModal/CustomModal";

const validationSchema = yup.object({
    name: yup.string().required('Required field'),
    subject: yup.string().required('Required field'),
    message: yup.string().required('Required field'),
    email: yup.string().email("invalid format").required('Required field'),
})

const ContactUsForm = () => {

    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean | null>(false)
    const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean | null>(false)
    const [email, setEmail] = useState(sessionStorage.getItem("email") || "");

    useEffect(() => {
        const interval = setInterval(() => {
            const sessionEmail = sessionStorage.getItem("email");
        if (sessionEmail === null || email !== sessionEmail) setEmail(sessionEmail || "");
        }, 500);
        return () => clearInterval(interval);
    }, [email]);

    const contactForm = useFormik({
        initialValues: {
            name: "",
            email: email,
            subject: "",
            message: "",
        },
        validationSchema,
        onSubmit: async (values, formikHelpers) => {
            // let response = await fetch(process.env.REACT_APP_API_URL + 'api/mailer/sendContactFormData', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json;charset=utf-8'
            //     },
            //     body: JSON.stringify({
            //         subject: values.subject,
            //         name: values.name,
            //         email: values.email,
            //         message: values.message,
            //         })
            // });
            //
            // let result = await response.json();
            //
            // if (result === 'ok') {
            //     setIsSuccessModalOpen(true)
            //     formikHelpers.resetForm()
            // } else {
            //     setIsErrorModalOpen(true)
            // }

        }
    })

    return (
        <>
            <CustomModal setIsModalOpen={setIsSuccessModalOpen} isModalOpen={isSuccessModalOpen} type={"confirm"}>
                <div className={styles.popup_title}>
                    Success!
                </div>
                <div className={styles.popup_subtitle}>
                    Your request has been sent.
                </div>
                <div className={styles.popup_button_wrapper}>
                    <div className={styles.button_block}>
                        <MyBtn style={{padding: "8px 48px"}} title={"Ok"} onClick={() => setIsSuccessModalOpen(false)}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal setIsModalOpen={setIsErrorModalOpen} isModalOpen={isErrorModalOpen} type={"error"}>
                <div className={styles.popup_title}>
                    Oops!
                </div>
                <div className={styles.popup_subtitle}>
                    Something went wrong. Please try again later.
                </div>
                <div className={styles.popup_button_wrapper}>
                    <div className={styles.button_block}>
                        <MyBtn style={{padding: "8px 48px"}} buttonType={"error"} title={"Ok"} onClick={() => setIsErrorModalOpen(false)}/>
                    </div>
                </div>
            </CustomModal>

            <div className={classnames(styles.flex, styles.gap20)}>
                <div className={classnames(styles.gray_bg, styles.block)}>
                    <form onSubmit={contactForm.handleSubmit}>
                        <div className={styles.input_wrapper}>
                            <div className={styles.input_label}>* name</div>
                            <MyInput
                                id={"name"}
                                name={"name"}
                                value={contactForm.values.name}
                                onChange={contactForm.handleChange}
                            />
                            {
                                contactForm.touched.name
                                && contactForm.errors.name
                                && <div className={styles.error_text}>{contactForm.errors.name}</div>
                            }
                        </div>

                        <div className={styles.input_wrapper}>
                            <div className={styles.input_label}>* email</div>
                            <MyInput
                                id={"email"}
                                name={"email"}
                                value={contactForm.values.email}
                                onChange={contactForm.handleChange}
                            />
                            {
                                contactForm.touched.email
                                && contactForm.errors.email
                                && <div className={styles.error_text}>{contactForm.errors.email}</div>
                            }
                        </div>

                        <div className={styles.input_wrapper}>
                            <div className={styles.input_label}>* subject</div>
                            <MyInput
                                id={"subject"}
                                name={"subject"}
                                value={contactForm.values.subject}
                                onChange={contactForm.handleChange}
                            />
                            {
                                contactForm.touched.subject
                                && contactForm.errors.subject
                                && <div className={styles.error_text}>{contactForm.errors.subject}</div>
                            }
                        </div>

                        <div className={styles.input_wrapper}>
                            <div className={styles.input_label}>* message</div>
                            <MyTextarea
                                id={"message"}
                                name={"message"}
                                value={contactForm.values.message}
                                onChange={contactForm.handleChange}
                            />
                            {
                                contactForm.touched.message
                                && contactForm.errors.message
                                && <div className={styles.error_text}>{contactForm.errors.message}</div>
                            }
                        </div>

                        <div className={styles.contacts_button_wrapper}>
                            <div className={styles.button_block}>
                                <MyBtn title={"Send Message"} large type={"submit"}/>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>

    );
};

export default ContactUsForm;
